import { paragraphInit, paragraphAnim, paragraphOut } from '../timelines/paragraph';
import { appButtonInit, appButtonAnim, appButtonOut } from '../timelines/appButton';
import { gridHideInit, gridHideAnim, gridHideOut } from '../timelines/gridHide';
import audio from '../../audio';
import eventHub from '../../eventHub';
import { inApp } from '../../utils';

export function resultsEnter(el, delay = 0) {
  const ctx = el;
  const title = ctx.querySelector('.result__title h2');
  const text = ctx.querySelector('.result__content p');
  const gridHide = [...ctx.querySelectorAll('.grid-hide')];
  const gameResult = document.querySelector('.game-result');
  ctx.style.opacity = 0;

  setTimeout(() => {
    audio.play('result');

    ctx.style.opacity = 1;
    paragraphInit(title);
    paragraphInit(text);
    gridHideInit(gridHide);
    appButtonInit(ctx);
    paragraphAnim(title, delay);
    paragraphAnim(text, delay + 300);
    gridHideAnim(gridHide, delay).finished.then(() => {
      if (window.innerWidth < 768) eventHub.$emit('showIllustration', 2200);
      appButtonAnim(ctx, delay + window.innerWidth < 768 ? 2700 : 1000);
      if (!inApp() && window.innerWidth < 768) eventHub.$emit('showCollectionLink', true, 3200);
      setTimeout(() => gameResult.setAttribute('data-hidden', ''), 3200);
    });
  }, 500);
}

export function resultsLeave(el, delay = 0) {
  const ctx = el;
  const title = ctx.querySelector('.result__title h2');
  const text = ctx.querySelector('.result__content p');
  const gridHide = [...ctx.querySelectorAll('.grid-hide')];

  paragraphOut(title, delay);
  paragraphOut(text, delay + 300);
  gridHideOut(gridHide, delay + 700);
  return appButtonOut(ctx, delay + 500);
}
